import { SummaryCardStates, SummaryCardVariants, } from '../../../../../components/summaryCard/types/summaryCardTheme';
import { commonTokens } from './commonTokens';
export const getSummaryCardStyles = (FOUNDATIONS, FONT) => ({
    [SummaryCardVariants.ACCOUNT]: {
        [SummaryCardStates.DEFAULT]: {
            ...commonTokens(FOUNDATIONS, {
                headerContainer: {
                    background_color: FOUNDATIONS.color_product_accounts_bg_50,
                },
                bodyContainer: {
                    hasHiddenContent: true,
                },
                decorativeTokens: {
                    color: FOUNDATIONS.color_product_accounts_icon_400,
                },
            }),
        },
        [SummaryCardStates.DISABLED]: {
            ...commonTokens(FOUNDATIONS, {
                mainContainer: {
                    pointer_events: 'none',
                },
                headerContainer: {
                    background_color: FOUNDATIONS.color_product_accounts_bg_50,
                    opacity: '0.5',
                },
                bodyContainer: {
                    hasHiddenContent: true,
                },
                decorativeTokens: {
                    color: FOUNDATIONS.color_product_accounts_icon_400,
                },
            }),
        },
    },
    [SummaryCardVariants.CARD]: {
        [SummaryCardStates.DEFAULT]: {
            ...commonTokens(FOUNDATIONS, {
                headerContainer: {
                    height: '100%',
                    border_bottom_left_radius: FOUNDATIONS.radius_250,
                    border_bottom_right_radius: FOUNDATIONS.radius_250,
                    cursor: 'pointer',
                    padding_top: FOUNDATIONS.spacing_00,
                    padding_bottom: FOUNDATIONS.spacing_00,
                    overflow: 'hidden',
                    pointer_events: 'auto',
                },
                bodyContainer: {
                    position: 'absolute',
                    bottom: FOUNDATIONS.spacing_150,
                },
            }),
        },
        [SummaryCardStates.DISABLED]: {
            ...commonTokens(FOUNDATIONS, {
                mainContainer: {
                    pointer_events: 'none',
                },
                headerContainer: {
                    height: '100%',
                    border_bottom_left_radius: FOUNDATIONS.radius_250,
                    border_bottom_right_radius: FOUNDATIONS.radius_250,
                    cursor: 'pointer',
                    padding_top: FOUNDATIONS.spacing_00,
                    padding_bottom: FOUNDATIONS.spacing_00,
                    overflow: 'hidden',
                    opacity: '0.5',
                },
                bodyContainer: {
                    position: 'absolute',
                    bottom: FOUNDATIONS.spacing_150,
                },
            }),
        },
    },
    [SummaryCardVariants.COMMERCIAL]: {
        [SummaryCardStates.DEFAULT]: {
            ...commonTokens(FOUNDATIONS, {
                headerContainer: {
                    height: FOUNDATIONS.size_550,
                    box_shadow: 'none',
                },
            }),
        },
        [SummaryCardStates.DISABLED]: {
            ...commonTokens(FOUNDATIONS, {
                mainContainer: {
                    pointer_events: 'none',
                },
                headerContainer: {
                    height: FOUNDATIONS.size_550,
                    box_shadow: 'none',
                    opacity: '0.5',
                },
            }),
        },
    },
    [SummaryCardVariants.DEPOSITS]: {
        [SummaryCardStates.DEFAULT]: {
            ...commonTokens(FOUNDATIONS, {
                headerContainer: {
                    background_color: FOUNDATIONS.color_product_deposits_bg_50,
                },
                decorativeTokens: {
                    color: FOUNDATIONS.color_product_deposits_icon_400,
                },
            }),
        },
        [SummaryCardStates.DISABLED]: {
            ...commonTokens(FOUNDATIONS, {
                mainContainer: {
                    pointer_events: 'none',
                },
                headerContainer: {
                    background_color: FOUNDATIONS.color_product_deposits_bg_50,
                    opacity: '0.5',
                },
                decorativeTokens: {
                    color: FOUNDATIONS.color_product_deposits_icon_400,
                },
            }),
        },
    },
    [SummaryCardVariants.LOANS]: {
        [SummaryCardStates.DEFAULT]: {
            ...commonTokens(FOUNDATIONS, {
                headerContainer: {
                    background_color: FOUNDATIONS.color_product_loans_bg_50,
                },
                decorativeTokens: {
                    color: FOUNDATIONS.color_product_loans_icon_400,
                },
            }),
        },
        [SummaryCardStates.DISABLED]: {
            ...commonTokens(FOUNDATIONS, {
                mainContainer: {
                    pointer_events: 'none',
                },
                headerContainer: {
                    background_color: FOUNDATIONS.color_product_loans_bg_50,
                    opacity: '0.5',
                },
                decorativeTokens: {
                    color: FOUNDATIONS.color_product_loans_icon_400,
                },
            }),
        },
    },
});
//# sourceMappingURL=styles.js.map